export const MINIMAL_MOVING_STEP = 5;
export const DEFAULT_GAP_BETWEEN_ITEMS = {
    sm: 10.166,
    md: 24,
    lg: 24,
};
